import React from "react"
import PropTypes from "prop-types"
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles({
  wrapper: {
    minHeight: '100vh',
    minWidth: '100vw',
  }
});

const Layout = ({ children }) => {
  const classes = useStyles();

  return (
    <main className={classes.wrapper}>{children}</main>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
